import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";
import * as serviceWorker from "./serviceWorker";
import { ApolloProvider } from '@apollo/client'
import { Provider } from 'react-redux';
import store from './store';
import client from './utils/graphqlClient';
import { AnalyticsProvider } from "./components/Analytics/AnalyticsContext";
import env from './utils/env';

ReactDOM.render(
  <ApolloProvider client={client}>
      <Provider store={store}>
        <AnalyticsProvider GA_MEASUREMENT_ID={env.REACT_APP_GA_TRACKING_ID}>
          <App />
        </AnalyticsProvider>
      </Provider>
  </ApolloProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
